import React from 'react'
import Lottie from 'react-lottie'

import { styles } from './config'

const size = '100%'

const style = {
    width: size,
    height: size,
}

const BaseLottie = props => {
    return (
        <div style={styles}>
            <Lottie isClickToPauseDisabled speed={1} style={style} {...props} />
        </div>
    )
}

export { BaseLottie }
